import { getDoc, updateDoc, doc } from 'firebase/firestore';
import { db } from '../config/fbConfig';

export const syncSubjectsWithStudents = async (classId) => {
  const classRef = doc(db, 'classes', classId);
  const classSnap = await getDoc(classRef);
  if (!classSnap.exists()) return;

  const { students = [], subjects = [] } = classSnap.data();

  for (let studentId of students) {
    const studentRef = doc(db, 'students', studentId);
    const studentSnap = await getDoc(studentRef);
    if (!studentSnap.exists()) continue;

    const studentData = studentSnap.data();
    const enrollments = studentData.enrollments || [];

    // Find the enrollment for this class
    const enrollmentIndex = enrollments.findIndex(e => e.classId === classId);
    let currentEnrollment = enrollmentIndex !== -1 ? enrollments[enrollmentIndex] : null;

    // Get existing subjects if they exist
    const existingSubjects = currentEnrollment?.subjects || [];

    // Create updated subjects array
    const updatedSubjects = subjects.map(subject => {
      // Find if this subject already exists for the student
      const existingSubject = existingSubjects.find(s => s.subjectId === subject.id);
      
      // If subject exists, preserve the scores, otherwise initialize to 0
      return {
        subjectId: subject.id || '',
        teacherId: subject.teacherId || '',
        scores: existingSubject?.scores || {
          firstca: 0,
          secondca: 0,
          exam: 0,
        }
      };
    });

    if (enrollmentIndex !== -1) {
      // Update the enrollment's subjects while preserving other data
      enrollments[enrollmentIndex] = {
        ...currentEnrollment,
        subjects: updatedSubjects
      };
    } else {
      // Add new enrollment if missing
      enrollments.push({
        classId,
        subjects: updatedSubjects,
        // Add any other default enrollment fields here
      });
    }

    await updateDoc(studentRef, { enrollments });
  }
};